export default "Spillet er nu slut. \n\nJeres endelige Unit Cost for spillet endte på: \n\n<center><strong>%gameScore% NB/Unit</strong></center>\n";